const TAG_CONFIG = {
  // Type badges (3 types)
  improvement: {label: 'Improvement', className: 'badge-type badge-blue'},
  feature: {label: 'Feature', className: 'badge-type badge-green'},
  retired: {label: 'Retired', className: 'badge-type badge-orange'},

  // Scope badges (7 scopes)
  statistics: {label: 'Statistics', className: 'badge-scope'},
  configuration: {label: 'Configuration', className: 'badge-scope'},
  monitoring: {label: 'Monitoring', className: 'badge-scope'},
  authentication: {label: 'Authentication', className: 'badge-scope'},
  infrastructure: {label: 'Infrastructure', className: 'badge-scope'},
  integrations: {label: 'Integrations', className: 'badge-scope'},
  ui: {label: 'UI', className: 'badge-scope'},
  meter: {label: 'Meter', className: 'badge-scope'},
  ev: {label: 'EV Station', className: 'badge-scope'},
};

// Tags that should not be displayed
const HIDDEN_TAGS = new Set(['public-changelog']);

const ChangelogBadge = ({tag}) => {
  if (HIDDEN_TAGS.has(tag)) return null;

  const config = TAG_CONFIG[tag];
  if (!config) return null;

  return (
    <span className={`changelog-badge ${config.className}`}>
      {config.label}
    </span>
  );
};

export default ChangelogBadge;
